import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import CartDrawer from './CartDrawer';
import { Toaster } from 'react-hot-toast';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000,
          style: {
            background: '#0D0D0D',
            color: '#FFFFFF',
            fontSize: '12px',
            letterSpacing: '0.05em',
            fontFamily: 'Montserrat, sans-serif',
          },
        }}
      />
      <Navbar />
      <main className="flex-1">
        {children}
      </main>
      <CartDrawer />
      <Footer />
    </div>
  );
};

export default Layout;